import { render, staticRenderFns } from "./RewardCheck.vue?vue&type=template&id=6b2c2a6e&scoped=true"
import script from "./RewardCheck.vue?vue&type=script&lang=js"
export * from "./RewardCheck.vue?vue&type=script&lang=js"
import style0 from "./RewardCheck.vue?vue&type=style&index=0&id=6b2c2a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2c2a6e",
  null
  
)

export default component.exports